import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useRef
} from "react"
import io from "socket.io-client"
import { useReduxStore } from "../hooks/useReduxStore"
import { ImageUrl } from "../services/API"

const SocketContext = createContext(undefined)

export const useSocket = () => {
  const context = useContext(SocketContext)
  if (context === undefined) {
    throw new Error("useSocket must be used within a SocketProvider")
  }
  return context
}

export const SocketProvider = ({ children }) => {
  const {getState,dispatch}=useReduxStore()
  const {userData,token}=getState("AUTH")
  const {adminToken}=getState("ADMIN_AUTH")
  const [socket, setSocket] = useState(null)
  const [isConnected, setIsConnected] = useState(false)
  const [isConnecting, setIsConnecting] = useState(false)
  const socketRef = useRef(null)

  console.log(
    "SocketProvider initialized - isAuthenticated:",
    "hasToken:",
    !!token
  )

  useEffect(() => {
    if ( token && !isConnecting && !socketRef.current) {
      console.log("Connecting to socket with token:", token,adminToken)
      setIsConnecting(true)
     console.log("token ya admin token ",token||adminToken)
      // Add a small delay to ensure the user is properly registered
      const connectSocket = () => {
        const newSocket = io(ImageUrl, {
          auth: {
            token: token
          },
          extraHeaders:{
            'ngrok-skip-browser-warning': 'true',
          }
        })

        newSocket.on("connect", () => {
          console.log("✅ Frontend connected:", newSocket.id)
          console.log("✅ Socket connection status:", newSocket.connected)
          setIsConnected(true)
          setIsConnecting(false)
        })

        newSocket.on("disconnect", () => {
          console.log("❌ Frontend disconnected")
          setIsConnected(false)
          setIsConnecting(false)
        })

        newSocket.on("connect_error", error => {
          console.log("❌ Frontend connection error:", error)
          console.error("Error details:", {
            message: error?.message || "Unknown error",
            description: error?.description,
            context: error?.context,
            type: error?.type
          })
          setIsConnected(false)
          setIsConnecting(false)

          // If it's an authentication error, try again after a delay
          if (
            error?.message?.includes("User not found") ||
            error?.message?.includes("Authentication error")
          ) {
            console.log("Retrying socket connection in 2 seconds...")
            setTimeout(() => {
              if ( token && !isConnecting) {
                connectSocket()
              }
            }, 2000)
          }
        })

        socketRef.current = newSocket
        setSocket(newSocket)
      }

      // Connect immediately
      connectSocket()

      return () => {
        if (socketRef.current) {
          socketRef.current.close()
          socketRef.current = null
        }
        setSocket(null)
        setIsConnected(false)
        setIsConnecting(false)
      }
    } 
    if ( adminToken && !isConnecting && !socketRef.current) {
      console.log("Connecting to socket with token:", token,adminToken)
      setIsConnecting(true)
     console.log("token ya admin token ",token||adminToken)
      // Add a small delay to ensure the user is properly registered
      const connectSocket = () => {
        const newSocket = io(ImageUrl, {
          auth: {
            token: adminToken
          },
          extraHeaders:{
            'ngrok-skip-browser-warning': 'true',
          }
        })

        newSocket.on("connect", () => {
          console.log("✅ Frontend connected:", newSocket.id)
          console.log("✅ Socket connection status:", newSocket.connected)
          setIsConnected(true)
          setIsConnecting(false)
        })

        newSocket.on("disconnect", () => {
          console.log("❌ Frontend disconnected")
          setIsConnected(false)
          setIsConnecting(false)
        })

        newSocket.on("connect_error", error => {
          console.log("❌ Frontend connection error:", error)
          console.error("Error details:", {
            message: error?.message || "Unknown error",
            description: error?.description,
            context: error?.context,
            type: error?.type
          })
          setIsConnected(false)
          setIsConnecting(false)

          // If it's an authentication error, try again after a delay
          if (
            error?.message?.includes("User not found") ||
            error?.message?.includes("Authentication error")
          ) {
            console.log("Retrying socket connection in 2 seconds...")
            setTimeout(() => {
              if ( token && !isConnecting) {
                connectSocket()
              }
            }, 2000)
          }
        })

        socketRef.current = newSocket
        setSocket(newSocket)
      }

      // Connect immediately
      connectSocket()

      return () => {
        if (socketRef.current) {
          socketRef.current.close()
          socketRef.current = null
        }
        setSocket(null)
        setIsConnected(false)
        setIsConnecting(false)
      }
    } 
    else if ( !token&&!adminToken) {
      // Clean up when not authenticate
      // d
      console.log("Admin aur token not available---------",token,adminToken)
      if (socketRef.current) {
        socketRef.current.close()
        socketRef.current = null
      }
      setSocket(null)
      setIsConnected(false)
      setIsConnecting(false)
    }
  }, [ token,adminToken])

  const joinConversation = conversationId => {
    if (socket) {
      socket.emit("join_conversation", { conversationId })
    }
  }

  const leaveConversation = conversationId => {
    if (socket) {
      socket.emit("leave_conversation", { conversationId })
    }
  }

  const sendMessage = data => {
    if (socket) {
      console.log("📤 Sending message via socket:", data)
      console.log("📤 Socket connected:", socket.connected)
      console.log("📤 Socket ID:", socket.id)
      socket.emit("send_message", data)
    } else {
      console.log("❌ Cannot send message - socket not available")
    }
  }

  const startTyping = conversationId => {
    if (socket) {
      socket.emit("typing_start", { conversationId })
    }
  }

  const stopTyping = conversationId => {
    if (socket) {
      socket.emit("typing_stop", { conversationId })
    }
  }

  const markAsSeen = (messageId, conversationId) => {
    if (socket && conversationId) {
      console.log("👁️ Sending mark_as_seen event:", {
        messageId,
        conversationId
      })
      socket.emit("mark_as_seen", { messageId, conversationId })
    } else {
      console.log(
        "⚠️ Cannot mark as seen - socket or conversationId not available:",
        {
          hasSocket: !!socket,
          conversationId
        }
      )
    }
  }

  const value = {
    socket,
    isConnected,
    joinConversation,
    leaveConversation,
    sendMessage,
    startTyping,
    stopTyping,
    markAsSeen
  }

  return (
    <SocketContext.Provider value={value}>{children}</SocketContext.Provider>
  )
}
